import { Box, styled, Typography, useTheme } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { Trans } from 'react-i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Color, Level } from 'theme/enums';

import { Warning } from './Warning';

interface IProps {
  label?: string;
  value?: number | string;
  options?: {
    classNames?: string;
    wrapperSx?: SxProps;
    valueProps?: { color?: Color; level?: Level; onClick?: () => void };
    warning?: string | JSX.Element;
    onWarningClick?: () => void;
  };
}

const ValueWrapper = styled(Typography)({
  fontSize: 'inherit',
  fontWeight: 700,
});

export const Total = ({ label, value = DEFAULT_PLACEHOLDER, options = {} }: IProps) => {
  const theme = useTheme();

  const {
    classNames = '',
    wrapperSx = {},
    valueProps = {},
    warning = '',
    onWarningClick,
  } = options;

  const totalContent = (
    <Trans
      i18nKey={'titleTotalValue'}
      values={{ label, value }}
      components={{
        valueWrapper: (
          <ValueWrapper color={warning ? Color.DANGER : null} {...valueProps}></ValueWrapper>
        ),
      }}
    />
  );

  return (
    <Box className={classNames}>
      <Box
        sx={{
          display: 'flex',
          gap: '4px',
          color: theme.palette.neutral[600],
          fontWeight: 500,
          ...wrapperSx,
        }}
      >
        {warning && (
          <Warning tooltipTitle={warning} content={totalContent} onClick={onWarningClick} />
        )}

        {!warning && totalContent}
      </Box>
    </Box>
  );
};
